import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ReportPipesModule } from "app/components/report/report-pipes";
import { CameraEvent } from 'app/models/report.model';
import { MomentPipe, TransformToLangCodePipe } from 'app/pipes/pipes';
import { HelperService } from 'app/services/helper.service';


@Component({
    selector: 'app-report-camera-event-table',
    templateUrl: './report-camera-event-table.component.html',
    styleUrls: ['../../report.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
        TranslateModule,
        CommonModule,
        InfiniteScrollModule,
        ReportPipesModule,
        MomentPipe,
        TransformToLangCodePipe
    ]
})
export class ReportCameraEventTableComponent {
  private activationsCache: any[] | null = null;

  constructor(private helper: HelperService) { }

  @Input() cameraEvents: CameraEvent[];
  @Input() infiniteScrollDisabled: boolean;

  @Output() loadNextEvents = new EventEmitter<void>();
  @Output() openLinkedAlert = new EventEmitter<string>();

  expandRow(cameraEvent: CameraEvent): void {
    cameraEvent.expanded = !cameraEvent.expanded;
  }

  openLinkedAlertHandler(cameraEvent: CameraEvent): void {
    const alertId = cameraEvent?.alert?.id;
    if (!alertId) {
      return;
    }
    this.openLinkedAlert.emit(alertId);
  }

  getRelatedAlertName(cameraEvent: CameraEvent): string {
    const alert = cameraEvent?.alert;
    const group = Number(alert?.activationGroup);
    const node = Number(alert?.activationNode);
    const deviceType = (alert?.deviceType || "").trim();
    const connTimeLimit = Number(alert?.connTimeLimit) || 0;

    const resolved = this.helper.getActivationName(
      group,
      node,
      deviceType,
      null,
      connTimeLimit
    );

    if (resolved !== `${group}-${node}`) {
      return resolved;
    }

    const activations = this.getActivationsFromCache();
    const fallback = activations.find((item: any) =>
      Number(item.group) === group && Number(item.node) === node
    );

    if (!fallback?.name) {
      return resolved;
    }

    return fallback.name.replace("%CTL%", this.helper.convertConnTimeLimit(connTimeLimit));
  }

  private getActivationsFromCache(): any[] {
    if (!this.activationsCache) {
      try {
        this.activationsCache = JSON.parse(localStorage.getItem("act") || "[]");
        if (!Array.isArray(this.activationsCache)) {
          this.activationsCache = [];
        }
      } catch {
        this.activationsCache = [];
      }
    }

    return this.activationsCache;
  }
};
